import LRUCache from "lru-cache"

// Nested LRUCache: the outer cache is keyed by `${storeId}-${cameraId}` and
// bounds how many cameras we track (evicting the least-recently-viewed
// camera first)
// Each camera's value is itself an LRUCache of its clips, bounded + TTL'd.
// Cache individual clip pointers per camera, keyed by start_ts_ms. Signed URLs
// are valid for 1 hour; TTL evicts each clip at 55 min to stay safely within
// that window.

const CLIP_CACHE_TTL_MS = 55 * 60 * 1000
const CLIP_CACHE_MAX_CLIPS_PER_CAMERA = 50
const CLIP_CACHE_MAX_CAMERAS = 20
const CLIP_DURATION_MS = 5000
const clipPointerCache = new LRUCache({ max: CLIP_CACHE_MAX_CAMERAS }) // cacheKey -> LRUCache of clips

function getCameraClipCache(cacheKey) {
  let cache = clipPointerCache.get(cacheKey)
  if (!cache) {
    cache = new LRUCache({ max: CLIP_CACHE_MAX_CLIPS_PER_CAMERA, maxAge: CLIP_CACHE_TTL_MS })
    clipPointerCache.set(cacheKey, cache)
  }
  return cache
}

export function selectClipFromData(data, timestamp, rewind) {
  let clip_filepath,
    ts_filepath,
    next = 0,
    clip_start_ts_ms,
    next_clip_start_ts_ms
  for (const clip of data) {
    if (clip.start_ts_ms <= timestamp) {
      console.log(
        `selectClipFromData: clip.start_ts_ms:${clip.start_ts_ms}, timestamp:${timestamp}`
      )
      ;({ clip_filepath, ts_filepath, start_ts_ms: clip_start_ts_ms } = clip)
      if (!rewind && next > 0) {
        next_clip_start_ts_ms = data[next - 1].start_ts_ms
      }
      break
    }
    next++
  }
  return { clip_filepath, ts_filepath, clip_start_ts_ms, next_clip_start_ts_ms, next }
}

/**
 * Returns a cached clip-pointer result for (cacheKey, timestamp) if one is
 * close enough to be trusted, otherwise undefined.
 */
export function getCachedClipPointer(cacheKey, timestamp, rewind) {
  const cameraCache = getCameraClipCache(cacheKey)
  const entries = []
  cameraCache.forEach((clip, ts) => entries.push([ts, clip]))

  const cachedClips = entries.sort((a, b) => b[0] - a[0]).map(([, clip]) => clip)

  if (cachedClips.length === 0) return undefined

  const result = selectClipFromData(cachedClips, timestamp, rewind)
  // Only trust the cache if the matched clip actually starts close to the
  // requested timestamp; otherwise it's a stale clip from an unrelated
  // fetch window with a gap in between, and we should fetch fresh data.
  const isCloseEnough =
    result.clip_filepath && Math.abs(timestamp - result.clip_start_ts_ms) <= CLIP_DURATION_MS
  return isCloseEnough ? result : undefined
}

/**
 * Stores freshly-fetched clip pointers in the cache for future lookups.
 */
export function cacheClipPointers(cacheKey, clips) {
  const cameraCache = getCameraClipCache(cacheKey)
  for (const clip of clips) {
    if (clip.start_ts_ms) cameraCache.set(clip.start_ts_ms, clip)
  }
}
